import focusTrap from 'Assets/js//lib/focus-trap'
;(function () {
  const components = {
    modalInfoCardsTrigger: SAXX.Init.Component((node, ctx) => {
      const eventListenerAction = (e) => {
        const target = node.getAttribute('data-target')
        ctx.emit('modalInfoCardEvent', null, { target, action: 'open' })
      }

      node.addEventListener('click', eventListenerAction)
      node.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          eventListenerAction(e)
        }
      })
    }),
    modalInfoCardsModal: SAXX.Init.Component((node, ctx) => {
      const { firstNode } = focusTrap(node)

      node.addEventListener('keydown', (e) => {
        const isEscPressed = e.key === 'Escape' || e.keyCode === 27
        if (!isEscPressed) return

        ctx.emit('modalInfoCardEvent', null, { action: 'close' })
      })

      ctx.on('modalInfoCardEvent', (state, data) => {
        if (data.action === 'close') {
          node.classList.remove('modal-open')
        }

        if (data.target === node.id && data.action === 'open') {
          node.classList.add('modal-open')
          firstNode.focus()
        }
      })
    }),
    modalInfoCardsCloseTrigger: SAXX.Init.Component((node, ctx) => {
      const eventListenerAction = (e) => {
        ctx.emit('modalInfoCardEvent', null, { action: 'close' })
      }

      node.addEventListener('click', eventListenerAction)
      node.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          eventListenerAction(e)
        }
      })
    }),
  }
  Object.assign(SAXX.Init.Components, components)
})()
